import {OperatorNode} from '../expression/operator-node';
import {Serializable, SerializedEventSelector} from '../types/serialized-cohort-types';

export class EventSelector implements Serializable {
  constructor(
    public event: string,
    public selector?: OperatorNode,
  ) {}

  public serialize(): SerializedEventSelector {
    const serializedEventSelector: SerializedEventSelector = {event: this.event};
    if (this.selector) {
      serializedEventSelector.selector = this.selector.serialize();
    }

    return serializedEventSelector;
  }
}
